import React from "react";
// import SkillsList from "../elements/SkillsList";
// import Resume from "../../../resume.json";

function Skills() {
  return (
    <section className="section" id="about">
      <div className="container">
        <div className="content_title has-text-white">About</div>
        <div className="content_subtitle has-text-white">Education</div>
        <div className="columns about_container">
          <div className="column is-one-fifth about_sub_container"/>
          <div className="column is-1">
            <span>
                <img className="about_img" src="/images/ucberkeley.png" alt=""></img>
            </span>
          </div>
          <div className="column is-6">
            <div className="has-text-left">
              <div className="content_title_uni has-text-white is-capitalized about_title">University of California, Berkeley</div>
              <div className="content_content_uni has-text-white about_subtitle">MEng. in Electrical Engineering and Computer Science</div>
              <h4 className="content_content_uni has-text-white is-capitalized about_time">2021.08 - 2022.05 (expected)</h4>
            </div>
          </div>
          <div className="column is-1 about_sub_container"/>
        </div>
        <div className="columns about_container">
          <div className="column is-one-fifth about_sub_container"/>
          <div className="column is-1">
            <span>
                <img className="about_img" src="/images/twente.jpeg" alt=""></img>
            </span>
          </div>
          <div className="column is-6">
            <div className="has-text-left">
              <div className="content_title_uni has-text-white is-capitalized about_title">University of Twente, Netherlands</div>
              <div className="content_content_uni has-text-white about_subtitle">Exchange Student in Master Computer Science</div>
              <h4 className="content_content_uni has-text-white about_time">2019.01 - 2019.06</h4>
            </div>
          </div>
          <div className="column is-1 about_sub_container"/>
        </div>



        <div className="columns about_container">
          <div className="column is-one-fifth about_sub_container"/>
          <div className="column is-1">
            <span>
                <img className="about_img" src="/images/nctu.png" alt=""></img>
            </span>
          </div>
          <div className="column is-6">
            <div className="has-text-left">
              <div className="content_title_uni has-text-white is-capitalized about_title">National Chiao Tung University</div>
              <div className="content_content_uni has-text-white about_subtitle">M.S. in Multimedia Engineering </div>
              <h4 className="content_content_uni has-text-white about_time">2017.09 - 2020.08</h4>
            </div>
          </div>
          <div className="column is-1 about_sub_container"/>
          
        </div>
        <div className="columns about_container">
          <div className="column is-one-fifth about_sub_container"/>
          <div className="column is-1">
            <span>
                <img className="about_img" src="/images/nctu.png" alt=""></img>
            </span>
          </div>
          <div className="column is-6">
            <div className="has-text-left">
              <div className="content_title_uni has-text-white is-capitalized about_title">National Chiao Tung University</div>
              <div className="content_content_uni has-text-white about_subtitle">
                  B.S. in Computer Science
              </div>
              <h4 className="content_content_uni has-text-white about_time">2013.09 - 2017.06</h4>
            </div>
          </div>
          <div className="column is-1 about_sub_container"/>
          
        </div>

        {/* <div className="columns">
          <div className="column is-full">
              <div className="has-text-centered">
                <span className="icon has-text-link">
                  <i className="fas fa-3x fa-laptop-code"></i>
                </span>
                <h2 className="title is-5 has-text-white">Software Development</h2>
              </div>
              <SkillsList
                skills={Resume.skills
                  .filter(skill => skill.keywords.includes("Software Developer"))
                  .reduce((obj, item) => {
                    obj[item.name] = item.level;
                    return obj;
                  }, {})}
              />
            </div>
        </div> */}
      </div>
    </section>
  );
}

export default Skills;
